export enum VaultType {
    None,
    Audio,
    Document
}